import React, { useEffect, useState, useRef } from "react";
import Calendar from "react-calendar";

const MonthView = ({ selectedDate, handleNewDate, setAnimation }) => {
  const currDate = new Date();
  const [showCalendar, setShowCalendar] = useState(false);
  const [nextMonthAccessible, setNextMonthAccessible] = useState(false);
  const calendarRef = useRef(null); // Reference for calendar popup
  const month_name = ["Jan","Feb", "Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  
  useEffect(() => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();

    if (month === currDate.getMonth() && year === currDate.getFullYear()) {
      setNextMonthAccessible(false);
    } else {
      setNextMonthAccessible(true);
    }
  }, [selectedDate]);

  // Close the calendar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDateChange = (newDate) => {
    setShowCalendar(false);

    // Update the month in the parent component
    handleNewDate(newDate);
  };

  const addMonth = () => {
    if (nextMonthAccessible) {
      const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
      handleDateChange(newDate);
      // setDate((prevDate) => new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1));
      setAnimation("animate__animated animate__slideInRight fast-animation");
    }
  };

  const subMonth = () => {
    const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1);
    handleDateChange(newDate);
    setAnimation("animate__animated animate__slideInLeft fast-animation");
  };

  const isFutureMonth = (month, year) => {
    const currMonth = currDate.getMonth();
    const currYear = currDate.getFullYear();
    return year > currYear || (year === currYear && month > currMonth);
  };

  return (
    <>
        <i className="bi bi-arrow-left-circle-fill fs-2" 
          onClick={() => subMonth()}/>
        
        <label
          className="fs-2 p-2 cursor"
          onClick={() => setShowCalendar(!showCalendar)}>
          {month_name[selectedDate.getMonth()] + `'` + selectedDate.getFullYear()}
        </label>
        {showCalendar && (
          <div className="calendar-popup1" ref={calendarRef}>
            <Calendar
              onChange={handleDateChange}
              value={selectedDate}
              view="year"
              maxDetail="year"
              showNeighboringMonth={false}
              calendarType="US"
              maxDate={currDate}
              tileClassName={({ date }) => {
                const month = date.getMonth();
                const year = date.getFullYear();
                if (isFutureMonth(month, year)) {
                  return "disabled-month";
                }
                return null;
              }}
            />
          </div>
        )}
        <i disabled={nextMonthAccessible} 
          onClick={() => addMonth()}
          className={`fs-2 bi
            ${nextMonthAccessible ? "bi-arrow-right-circle-fill" : "bi-arrow-right-circle opacity-50"}`}></i>
      </>
  );
};

export default MonthView;
